import * as yup from 'yup';
import { REGEX_PATTERNS } from '@constants';

export default yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  phoneNumber: yup.string().required('Required').matches(REGEX_PATTERNS.Phone, {
    message: 'Invalid phone number',
  }),
  email: yup.string().required('Required').matches(REGEX_PATTERNS.Email, {
    message: 'Invalid email',
  }),
  region: yup.string().required(),
  language: yup.string().required(),
  orderName: yup.string().required(),
  insertProducts: yup.array().of(
    yup.object({
      vehicle: yup.lazy((value) => {
        switch (typeof value) {
          case 'object':
            return yup
              .object()
              .shape({
                text: yup.string().required('Required'),
                value: yup.string().required('Required'),
              })
              .nullable()
              .required('Required'); // schema for object
          case 'string':
            return yup.string().required('Required'); // schema for string
          default:
            return yup.mixed(); // here you can decide what is the default
        }
      }),
      contractPeriod: yup.lazy((value) => {
        switch (typeof value) {
          case 'object':
            return yup
              .object()
              .shape({
                text: yup.string().required('Required'),
                value: yup.string().required('Required'),
              })
              .nullable()
              .required('Required'); // schema for object
          case 'string':
            return yup.string().required('Required'); // schema for string
          default:
            return yup.mixed(); // here you can decide what is the default
        }
      }),
      quantity: yup.string().required('Required'),
      price: yup.string().required('Required'),
    })
  ),
});
